import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React from 'react';

import { ProviderType, AGENT_LABELS, AVAILABLE_AGENTS } from '@verantos-dev/types-common';

export interface AgentSelectorProps {
  selectedAgent: ProviderType;
  onAgentChange: (agent: ProviderType) => void;
  availableAgents?: readonly ProviderType[];
}

export const AgentSelector: React.FC<AgentSelectorProps> = ({
  selectedAgent,
  onAgentChange,
  availableAgents = AVAILABLE_AGENTS,
}) => {
  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <InputLabel>Agent</InputLabel>
      <Select
        value={selectedAgent}
        label="Agent"
        onChange={(e) => onAgentChange(e.target.value as ProviderType)}
      >
        {availableAgents.map((agent) => (
          <MenuItem key={agent} value={agent}>
            {AGENT_LABELS[agent]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AgentSelector;
